





















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import VueBarcode from 'vue-barcode'
import InfiniteLoading from 'vue-infinite-loading'

import axios from 'axios'
import { jsPDF } from 'jspdf'
import 'svg2pdf.js'

import _capitalize from 'lodash/capitalize'
import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import _startsWith from 'lodash/startsWith'
import _trimStart from 'lodash/trimStart'

import Dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { Inventory } from '@/types'
import { BASE_URL } from '@/config'

Dayjs.extend(utc)
Dayjs.extend(timezone)

@Component({
  components: {
    VueBarcode,
    InfiniteLoading,
  },
  methods: {
    _capitalize,
    _get,
  },
})
export default class CheckInHistoryPage extends Vue {
  @Prop()
  private readonly offerId: string | undefined
  @Prop({ required: true })
  private readonly checkedIn: boolean | undefined
  @Prop({ required: true })
  private readonly requestPrintInventoryId: string | undefined
  @Prop({ required: true })
  private readonly requestDeleteInventoryId: string | undefined

  private infiniteId: number = new Date().getTime()
  private itemsPerPage: number = 20
  private offset: number = 0
  private inventories: Inventory[] = []

  @Watch('offerId')
  private offerIdChanged(newVal: any | undefined) {
    this.offset = 0
    if (newVal) {
      this.infiniteId += 1
    } else {
      this.inventories = []
    }
  }

  @Watch('checkedIn')
  private checkedInChanged(newVal: any | undefined) {
    if (newVal) {
      this.offset = 0
      this.inventories = []
      this.infiniteId += 1
    }
  }

  @Watch('requestDeleteInventoryId')
  private requestDeleteInventoryIdChanged(newVal: string | null, oldVal: string | null) {
    if (!newVal && oldVal) {
      this.inventories = this.inventories.filter(i => i.id !== oldVal)
    }
  }

  private mounted(): void {}

  private destroyed(): void {}

  private getInventoryDate(inventory): string {
    const temp = _get(inventory, ['updatedAt'])
    return temp
      ? `${Dayjs(temp)
          .tz('America/Chicago')
          .format('MM/DD/YYYY h:mm:ss A')} CST`
      : ''
  }

  private infiniteHandler($state) {
    if (!this.offerId) {
      $state.loaded()
      $state.complete()
      return
    }

    const path = `${BASE_URL}/check-in`
    axios
      .get(path, {
        params: {
          offerId: this.offerId,
          limit: this.itemsPerPage,
          offset: this.offset,
          order: [],
        },
      })
      .then(response => {
        const tempInventories = _get(response, 'data')
        $state.loaded()
        if (tempInventories.length < this.itemsPerPage) {
          $state.complete()
        }
        this.inventories = !this.offset
          ? tempInventories
          : [...this.inventories, ...tempInventories]
        this.offset += tempInventories.length || 0
      })
      .catch(err => {
        $state.loaded()
        $state.complete()
      })
      .finally(() => {})
  }
}
